import useAuth from 'client/utils/auth/useAuth';
import { useEffect, useState } from 'react';
import LoadingPage from 'client/pages/LoadingPage/LoadingPage';
import ErrorBoundary from 'client/utils/routes/ErrorBoundary/ErrorBoundary';
import { difference, intersection } from 'lodash';
import { MsalAuthenticationTemplate } from '@azure/msal-react';
import PropTypes from 'prop-types';
import { loginRedirect } from 'client/utils/auth/msalHelpers';

const RequiresAuth = ({ children, requiredPermissions, requiresAll }) => {
    const { permissions, isAuthenticated } = useAuth();
    const [loading, setLoading] = useState(true);
    const [isPermitted, setIsPermitted] = useState(false);

    useEffect(() => {
        setLoading(true);
        const hasPermission = isAuthenticated && (Boolean(!requiredPermissions) || requiredPermissions.length === 0 ||
        (requiresAll
            ? difference(requiredPermissions, permissions).length === 0
            : intersection(requiredPermissions, permissions).length > 0));
        setIsPermitted(hasPermission);
        setLoading(false);
    }, [permissions]);

    if (loading) {
        return <LoadingPage/>;
    }

    if (!isAuthenticated) {
        loginRedirect(); // lint might give a warning in the IDE here but it's fine, we don't need to handle the promise
        return <LoadingPage/>;
    }

    /**
     * Gracefully handles redirect managing MSAL interactions if redirect not
     * already triggered by authenticated loader.
     */
    return <MsalAuthenticationTemplate>{
        isPermitted ? [children] : <ErrorBoundary error={{ statusCode: 403 }}/>
    }</MsalAuthenticationTemplate>;
};

RequiresAuth.propTypes = {
    requiredPermissions: PropTypes.array.isRequired,
    requiresAll: PropTypes.bool,
    children: PropTypes.object
};

RequiresAuth.defaultProps = {
    requiresAll: false,
    requiredPermissions: []
};
export default RequiresAuth;
